export const CODE_LENGTH = 6;

interface CodeBoxProps {
  value: string;
  isFocused: boolean;
  isDisabled: boolean;
  onClick: () => void;
}

export function CodeBox({ value, isFocused, isDisabled, onClick }: CodeBoxProps) {
  const baseClasses = 'w-12 h-14 flex items-center justify-center text-2xl font-semibold rounded-lg border-2 transition-all duration-200 select-none';

  const stateClasses = isDisabled
    ? 'bg-surface border-border opacity-50 cursor-not-allowed'
    : isFocused
      ? 'bg-field border-primary ring-2 ring-primary/20 text-onfield cursor-text'
      : 'bg-field border-border text-onfield hover:border-primary/50 cursor-pointer';

  return (
    <div
      className={`${baseClasses} ${stateClasses}`}
      onClick={!isDisabled ? onClick : undefined}
    >
      {value || (isFocused && <span className="animate-pulse">|</span>)}
    </div>
  );
}
